import { ProductTable } from "callable-data-objects";
import { DBReference } from "callable-data-objects/dist/models/accountDevice/AccountDevice";
import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const ProductTableSelect = ({ label, productTables, ...props }: any) => {
  const [field, meta, helpers] = useField(props);

  const opts = productTables.map((rt: ProductTable) => {
    return {
      text: rt.name,
      value: rt.id,
    };
  });

  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        label={label}
        fluid
        search
        selection
        options={opts}
        name={field.name}
        value={field.value?.id}
        placeholder="Select Product Table"
        onChange={(event, { value }) => {
          const product = productTables.find(
            (p: ProductTable) => p.id === value
          );
          const dbRef: DBReference = {
            id: product.id,
            name: product.name,
          };
          helpers.setValue(dbRef);
        }}
      />
      {meta.error && (
        <Label basic color="red" pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default ProductTableSelect;
